module.exports = __webpack_public_path__ + "static/assets/39563f3b38b1fdb805323b1f69dace54.mp3";